<template>
    <div>
        <!-- Titulo Lista -->
        <v-row>
            <div class="text-h5" :title="item.lista_object.id">
                {{item.lista_object.codperlet}} - {{item.lista_object.titulo}}
            </div>
            <v-spacer></v-spacer>
            <v-btn text @click="reload_lista_aluno"
                :loading="$store.state.checklistdb.loading_id=='get-aluno-lista'">
                Atualizar
                <v-icon>mdi-refresh</v-icon>
            </v-btn>
        </v-row>
        <v-divider class="my-4"></v-divider>
        <!-- Aluno -->
        <v-row class="mt-3">
            <div class="text-h6">
                {{item.ra}} - {{item.nome}}
            </div>
            <v-spacer></v-spacer>
            <v-btn color="error" small @click="deleteListaAluno" v-if="$verify.pode_gerenciar_checklistdb()">
                <v-icon>mdi-delete</v-icon>
                Remover Lista
            </v-btn>
        </v-row>
        <!-- Tabela -->
        <v-row>
            <v-data-table
                class="custom-header-style"
                :items-per-page="100"
                locale="pt-BR"
                :items="item.material_objects"
                :headers="headers">
                <!-- eslint-disable-next-line -->
                <template #item.recebido="{ item }">
                    {{item.qtde_entregue}}/{{item.lista_material_object.qtde_exigida}} Recebidos
                </template>
                <!-- eslint-disable-next-line -->
                <template #item.item_total_devido_real="{ item }">
                    <v-chip :color="item.item_total_devido_decimal !== 0 ? 'error darken-2': 'success darken-2'">
                        {{item.item_total_devido_real}}
                    </v-chip>
                </template>
                <!-- eslint-disable-next-line -->
                <template #item.status_entregue="{ item }">
                    <v-chip
                        :color="status_to_label(item.status_entregue).color">
                        <v-avatar left v-show="$store.state.checklistdb.loading_id==`recebendo-${item.id}`">
                            <v-btn icon loading></v-btn>
                        </v-avatar>
                        <b>{{status_to_label(item.status_entregue).label}}</b>
                    </v-chip>
                    <loading-gdb :dialog="[`recebendo-${item.id}`].includes($store.state.checklistdb.loading_id)" :text="'Recebendo '+item.lista_material_object.material_object.descricao"/>
                </template>
                <!-- eslint-disable-next-line -->
                <template #item.recebendo="{ item }">
                    <v-select class="my-1" hide-details
                        v-show="item.lista_material_object.qtde_exigida - item.qtde_entregue > 0"
                        v-model="item.recebendo"
                        placeholder="Receber..."
                        @update:modelValue="onSelectRecebendo($event, item)"
                        :items="create_range(item.lista_material_object.qtde_exigida, item.qtde_entregue)">
                        <template v-slot:append>
                            Itens
                        </template>
                    </v-select>
                </template>
            </v-data-table>
        </v-row>
        <!-- valores Lista -->
        <v-row>
            <v-col cols="12" sm="4">
                <span>R$ Lista</span>
                <helper-gdb :text="item.valor_total_lista" />
            </v-col>
            <v-col cols="12" sm="4">
                <span>R$ Devido</span>
                <helper-gdb :text="item.valor_total_devido_real" />
            </v-col>
            <v-col cols="12" sm="4" align="right">
                <v-chip color="primary" @click="enviarComprovante(item.id)">
                    <v-icon small>mdi-email</v-icon>&nbsp; Enviar Comprovante...
                </v-chip>
                <v-chip class="ma-1" label
                    @click.prevent="imprimir()"
                    color="error darken-2" small>
                    <v-icon small>mdi-printer</v-icon>
                    &nbsp; Imprimir
                </v-chip>
            </v-col>
        </v-row>
        <!-- Taxas -->
        <v-row v-if="taxas.length > 0 && !item.lista_completa">
            <v-col cols="12">
                <!-- LANCAMENTOS -->
                <v-card variant="outlined" class="mt-3 pa-1">
                    <v-chip color="error" class="darken-2">
                        <v-icon>mdi-barcode</v-icon>
                        ({{taxas.length}}) Boleto(s) referente(s) a Taxa de Material encontrado(s) no TOTVS RM
                    </v-chip>
                    <div>
                        <small>
                            <i>
                                * Esta consulta é apenas para visualização de
                                taxas encontradas para o aluno no respectivo
                                período letivo, e que pode não representa um
                                boleto como sendo a taxa gerada para o fim desta lista.
                            </i>
                        </small>
                    </div>
                    <div class="pa-1" >
                        <div v-for="tx, ind in taxas" :key="'taxa_'+ind">
                            <v-divider class="my-2"></v-divider>
                            <v-row>
                                <div class="boleto">Ref: {{tx.NOMESERVICO}}</div>
                                <v-spacer></v-spacer>
                                <div class="boleto">Titular: {{tx.NOMEFANTASIA}}</div>
                            </v-row>
                            <v-row>
                                <div class="boleto">
                                    {{tx.STATUS_LAN_DESC}} e {{tx.SITUACAO_VENCIMENTO}}
                                </div>
                                <v-spacer></v-spacer>
                                <div class="boleto">Valor Orig.: {{tx.VALORORIGINAL}}</div>
                                <v-spacer></v-spacer>
                                <div class="boleto">Valor baixado: {{tx.VALORBAIXADO}}</div>
                            </v-row>
                            <v-row>
                                <div class="boleto">Data Emissão: {{tx.DATAEMISSAO.split('T')[0]}}</div>
                                <v-spacer></v-spacer>
                                <div class="boleto">Data Vencimento: {{tx.DATAVENCIMENTO.split('T')[0]}}</div>
                            </v-row>
                            <v-row>
                                <div class="boleto" style="word-break: break-all">Cód Barras: <samp>{{tx.CODIGOBARRA}}</samp></div>
                            </v-row>
                        </div>
                    </div>
                </v-card>
            </v-col>
            <helper-gdb text="ListaAluno" v-if="$store.getters.StateAuthenticatedUser.is_superuser"/>
        </v-row>
        <div>
            <!-- IMPRESSAO PDF -->
            <div id="imprimir-pdf" v-show="false">
                <div>
                    <div style="text-align:center">
                        <h3 style="font-family: monospace !important;">{{item.ra}} - {{item.nome}}</h3>
                    </div>
                    <div style="text-align:center">
                        <h3 style="font-family: monospace !important;">Status de Materiais Recebidos</h3>
                    </div>
                    <samp v-for="status, si in Array.from(new Set(item.material_objects.map(obj => obj.status_entregue)))" :key="'status_'+si" >
                        <hr class="my-2"/>
                        <div>
                            <h3 :style="`font-family: monospace !important;`"
                            >Status: {{status_to_label(status).label}}</h3>
                        </div>
                        <div v-for="material, mi in item.material_objects.filter(obj => obj.status_entregue === status)" :key="'material_'+mi" style="font-size: 16px !important; margin: 10px">
                            <div style="font-family: monospace !important;">{{material.lista_material_object.material_object.descricao}} - {{material.qtde_entregue}}/{{material.lista_material_object.qtde_exigida}}</div>
                            <div v-for="log, li in material.logrecebimentomaterial_set" :key="li" style="margin-left: 10px;font-family: monospace !important;">
                                {{log.qtde_recebida}} item(s) recebidos em {{new Date(log.datahora).toLocaleDateString()}}
                            </div>
                            <pre v-show="false">{{material}}</pre>
                        </div>
                    </samp>
                    <div style="margin: 20px auto; text-align: center">
                        <br><br>
                        <br><br>
                        <div style="text-align: right;">
                            {{`São Luís, ${new Date().toLocaleDateString()}`}}
                        </div>
                        <br><br>
                        <div style="text-align: center">
                            Estou de acordo com os itens recebidos descritos acima
                        </div>
                        <div style="text-align: center; margin-top: 10px">
                            ________________________________
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <loading-gdb :dialog="['get-aluno-lista'].includes($store.state.checklistdb.loading_id)" text="Carregando lista..."/>
        <loading-gdb :dialog="['get-taxa-materiais'].includes($store.state.checklistdb.loading_id)" text="Verificando taxas..."/>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    props: {
        item: {
            required: true,
            default: {}
        }
    },
    data: () => ({
        legenda_status_entrega: {
            NAO_ENTREGUE: {
                label: 'Não Entregue',
                color: 'grey'
            },
            ENTREGA_PARCIAL: {
                label: 'Parcial',
                color: 'info'
            },
            ENTREGUE_TOTAL: {
                label: 'Entregue',
                color: 'success'
            },
            ENTREGUE_SOBRA: {
                label: 'Em Excesso',
                color: 'success'
            },
            DESCONHECIDO: {
                label: 'Desconhecido',
                color: 'secondary'
            },
        },
        taxas: [],
        headers: [
            { title: 'Material', align: 'start', sortable: true, value: 'lista_material_object.material_object.descricao', width:'100'},
            { title: 'Recebido', align: 'center', sortable: false, value: 'recebido', width:'50'},
            { title: 'Status', align: 'start', sortable: false, value: 'status_entregue', width:'50'},
            { title: 'Recebendo', align: 'center', sortable: false, value: 'recebendo', width:'160'},
        ]
    }),
    mounted(){
        this.load_taxa_materiais()
    },
    methods: {
        ...mapActions([
            'SendCheckListComprovante',
            'ReceberMaterialListaAluno',
            'GetCheckListAlunoLista',
            'DeleteCheckListAlunoLista',
            'GetCheckListTaxaMateriais'
        ]),
        status_to_label(status){
            try{
                return this.legenda_status_entrega[status]
            }catch{
                return { label: 'Ops', color: 'grey' }
            }
        },
        create_range(exigido, entregue){
            let length = exigido - entregue
            // retorna uma lista com valores a partir de 1
            return Array.from({ length: length  }, (_, index) => index +1);
        },
        async onSelectRecebendo(recebendo, objeto){
            if (recebendo > 0){
                const confirmar_recebimento = confirm(`Confirma o recebimento de ${recebendo} ${objeto.lista_material_object.material_object.descricao}?`)
                if (confirmar_recebimento){
                    const id = objeto.id
                    const recebido = await this.ReceberMaterialListaAluno({ id, recebendo })
                    if (recebido){
                        this.$store.commit('setAlerts', [
                            {
                                tag:'success',
                                title:'Recebimento de material',
                                message: `(${recebendo}) [${objeto.lista_material_object.material_object.descricao}] recebido com sucesso`}])
                    }
                    this.reload_lista_aluno()
                }
            }
            objeto.recebendo = null
        },
        async reload_lista_aluno(){
            const id = this.item.id
            const lista = await this.GetCheckListAlunoLista(id)
            /* Devido à impossibilidade de alterar a prop diretamente, é enviado para o componente pai atualizar no $emit abaixo */
            this.$emit('on-refresh-prop-item', lista)
        },
        async load_taxa_materiais(){
            const ra = this.item.ra
            const codperlet = this.item.lista_object.codperlet
            const taxas = await this.GetCheckListTaxaMateriais({ra, codperlet})
            this.taxas = taxas
        },
        async deleteListaAluno(){
            const lista_aluno = this.item
            const confirma = confirm(`Tem certeza que deseja remover a lista ${lista_aluno.lista_object.titulo} de ${lista_aluno.lista_object.codperlet} do aluno ${lista_aluno.ra}-${lista_aluno.nome}? Isso também removerá todos os itens recebidos, se existir!`)
            if(!confirma) return
            const deleted = await this.DeleteCheckListAlunoLista(lista_aluno)
            if(deleted){
                this.$emit('on-deleted', lista_aluno)
            }else{
                console.error('ListaAluno não foi removida', lista_aluno)
            }
        },
        async enviarComprovante(id){
            await this.SendCheckListComprovante(id)
        },
        sendPrint(html){
            var win = window.open('');
            win.document.write(html);
            win.focus();
        },
        imprimir(){
            var page = ''
            var body = ''
            body = document.getElementById('imprimir-pdf')
            console.log(body)
            body = body.innerHTML
            let emitido_em = new Date().toLocaleDateString()
            page += `
                <html>
                <head>
                    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
                    <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@300&family=Poppins:wght@300&display=swap" rel="stylesheet">
                    <style>
                        @media print {
                            table{
                                width: 100%;
                                margin-bottom: 30px;
                                page-break-inside: avoid;
                            }
                            .pagebreak {
                                page-break-after: always;
                            }
                            *{
                                font-family: 'Poppins', sans-serif;
                                font-size: 11px;
                            }
                            h3{
                                font-family: 'Poppins', sans-serif;
                                font-size: 16px;
                            }
                            td, th {
                                /*border-bottom-style: solid;
                                border-bottom-width: 1px;
                                border-color: #aaa;*/
                            }
                            .item-tabela {
                                border-bottom-style: solid;
                                border-bottom-width: 1px;
                                border-color: #aaa;
                                margin-bottom: 10px;
                            }
                        }
                    </style>
                </head>
                <body>
                    <div style="display: inline-flex;margin-bottom:50px;width:100%">
                        <img src="/assets/img/logoDB.png" onload="window.print();window.close()"
                            width="160px" style="object-fit: contain;" />
                        <div style="width:100%; text-align:center">
                            <h3> Comprovante de recebimento de materiais</h3>
                        </div>
                        <div style="width:200px; text-align:right">
                            <div>
                                <small> Emitido em: ${emitido_em}</small>
                            </div>
                            <div>
                                <small> por: ${this.$store.getters.StateAuthenticatedUser.username}</small>
                            </div>
                        </div>
                    </div>
                    ${body}
                </body>
                </html>
            `;
            this.sendPrint(page)
        },
    },
    watch: {
        item: {
            handler(val){
                val
                this.load_taxa_materiais()
            }
        }
    }
}
</script>
<style scoped>
</style>